<script lang="ts" context="module">
    let resolve = writable<((...args: any) => any) | null>(null)
    let reject = writable<((err : Error) => void) | null>(null)
    const pwd = writable("")
    const err = writable("")
    export function openReAuth<T>() {
        const rej = get(reject)
        if (rej) {
            rej(new Error("Another re-authentication attempt overwrote this one"))
        }
        reset()
        return new Promise<T>((res, rej) => {
            resolve.set(res)
            reject.set(rej)
            pwd.set("")
            err.set("")
        })
    }

    globalThis.openReauth = openReAuth

    function reset() {
        resolve.set(null)
        reject.set(null)
        pwd.set("")
        err.set("")
    }

    function exit() {
        const res = get(resolve)
        const rej = get(reject)
        if (rej) rej(new Error("Exited re-authentication dialogue"))
        reset()
    }

    async function finish() {
        const res = get(resolve)
        const rej = get(reject)
        if (!res || !rej) {
            reset()
            if (!res) throw new Error("Finish was called but resolve not set")
            if (!rej) throw new Error("Finish was called but reject not set")
        }

        try {
            console.log(get(pwd))
            await reauth(get(pwd))
            res()
            reset()
        } catch (e) {
            console.warn(e)
            err.set(errorize(e))
        }
    }
</script>

<script lang="ts">
    import Password from "@components/material/Password.svelte"
    import PopupNoPortal from "@components/popup/PopupNoPortal.svelte"
    import PopupExit from "@components/popup/PopupExit.svelte"
    import { writable, get } from "svelte/store"
    import { reauth } from "@utils/underhood/firebase"
    import { errorize } from "@utils/underhood/firebase-errors"
    import Button from "@components/button/Button.svelte"
    import PopupHeading from "@components/popup/PopupHeading.svelte"
    import PopupBanner from "@components/popup/PopupBanner.svelte"

</script>

{#if $resolve && $reject}
    <PopupNoPortal>
        <PopupExit float on:exit={exit} />
        <PopupBanner>
            <PopupHeading>We need to make sure it's you!</PopupHeading>
            Please enter your password.
        </PopupBanner>
        {#if $err}
            <div class="text-red-500 mb-2"><b>Whoops!</b> {$err}</div>
        {/if}
        <form>
            <Password bind:value={$pwd} />
            <Button fullwidth class="mt-4" go={finish} icon="lock"
                >Re-Authenticate</Button
            >
        </form>
    </PopupNoPortal>
{/if}
